// Keep OAuth returns on the section that initiated setup. Detail URLs and
// query parameters are deliberately excluded from the server allowlist.
export function gmailReturnUrl(location: Pick<Location, 'origin' | 'pathname'> = window.location): string {
  const path = ['/app/settings/gmail', '/app/email/templates', '/app/email/automations'].find(
    (section) => location.pathname === section || location.pathname.startsWith(`${section}/`),
  ) ?? '/app/brief';
  return `${location.origin}${path}`;
}

const failures: Record<string, string> = {
  access_denied: 'Gmail wasn’t connected because access wasn’t approved. Try again when you’re ready and approve the requested Gmail access.',
  authorization_failed: 'Google could not authorize this connection. Try again; if Google blocks access, the server administrator needs to check the Google app setup.',
  disabled: 'Gmail connections are currently disabled on this server. Setup must be completed before you can connect.',
  token_exchange_failed: 'Google could not complete the connection. Try again. If it continues, the server administrator needs to check the Google credentials and Gmail callback address.',
  permission_missing: 'Gmail access wasn’t granted. Try again and approve the requested Gmail permission.',
  provider_unavailable: 'Google couldn’t be reached to finish connecting. Please try again.',
  gmail_api_disabled: 'The Gmail API needs to be enabled for this app’s Google Cloud project before you can connect.',
  mailbox_unavailable: 'Google could not open this account’s Gmail mailbox. Check that Gmail is available for this account and that your organization allows access.',
  identity_failed: 'Google could not verify the Gmail account. Please try connecting again.',
  replacement_requires_disconnect: 'A different Gmail account is already connected, or disconnection is still finishing. Disconnect the existing account and wait for removal before connecting another.',
  offline_access_missing: 'Google did not grant ongoing mailbox access. Try connecting again and approve the requested access.',
};

export function gmailConnectionError(search: string): string | undefined {
  const params = new URLSearchParams(search);
  if (params.get('gmail') !== 'connection_failed') return undefined;
  const reason = params.get('gmail_error') ?? '';
  return Object.hasOwn(failures, reason) ? failures[reason] :
    'Gmail wasn’t connected. Please try again. If it continues, ask the server administrator to check Gmail setup.';
}
